import { 
  Flex, 
  Loading,
} from "@components/index";
import { useAuthContext } from "@auth/context/Auth.context";

const style = { height: "100vh" };

const AuthGuard = ({ children }) => {
  const { 
    initialized,
    errorKeycloak,
  } = useAuthContext();

  if (!initialized) {
    return (
      <Flex block alignItems="center" justifyContent="center" style={style}>
        {!errorKeycloak && <Loading size="sm" />}
        {errorKeycloak && "Falha na autenticação. Verifique sua conexão!"}
      </Flex>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;